// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__5LAG7","productName":"Table_productName__xDDQS"};